import { MapTo } from "@adobe/aem-react-editable-components";
import { SmartSurveyPushBlock } from "@jti/ui";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const SmartSurveyPushBlockConfig = {
    emptyLabel: "Please fill in Survey section",
    isEmpty: (props) => {
        return (!props.title ||
            !props.ctaText ||
            !props.imgDesktop ||
            !props.description ||
            !props.orientation ||
            !props.surveyMonkeyPageUrl ||
            !props.dateOfUserRegistrationForSurvey);
    },
    getProps: (props) => {
        console.log("Props in is getProps:", { props });
        return {
            ...props,
            dateOfUserRegistrationForSurvey: new Date(props?.dateOfUserRegistrationForSurvey ?? new Date()).toISOString(),
        };
    },
};
export default MapTo("loyalty/components/smartSurveyPushBlock")(withAemAuthoring(SmartSurveyPushBlock, SmartSurveyPushBlockConfig));
